export const COLORS = [
    '#0064F9', 
    '#7400F9',
    '#407ee2', 
    '#5dcbfd', 
    '#22d9cb'
];

